export default "__VITE_ASSET__07a597d3__"